import { Component, OnInit, Input, TemplateRef, ViewChild, Output, EventEmitter } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { TranslateService } from '@ngx-translate/core';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { AppConfig } from 'src/app/app.config';
import { checkLocalizationLang } from 'ph-bhp-feature-packages/ph-bhp-feature-package-sopmanagement/lib/translation.utilities';
import { PHBHPLayoutPackageService } from 'ph-bhp-feature-packages/ph-bhp-layout-package/lib/ph-bhp-layout-package.service';
import { TranslationKeys } from 'ph-bhp-localization';
import { EventsService } from '../../../../src/app/services/events.service';

@Component({
  selector: 'lib-ph-bhp-selectlanguage',
  templateUrl: './selectlanguage.component.html',
  styleUrls: ['./selectlanguage.component.css']
})
export class SelectlanguageComponent implements OnInit {

  translationKeys: typeof TranslationKeys = TranslationKeys;

  constructor(
    public modalRef: BsModalRef,
    public translate: TranslateService,
    public layoutService: PHBHPLayoutPackageService,
    public config: AppConfig,
    private eventsService: EventsService) { }

  mygroup = new UntypedFormGroup({
    selectedlanguage: new UntypedFormControl('en')
  });

  emitData: any = {
    key: '',
    val: ''
  }


  @Input() choosenLanguage = 'English';

  ngOnInit() {
    let lang = localStorage.getItem('selectedlanguage')
    if (lang) {
      this.mygroup.patchValue({ selectedlanguage:  lang })
    }
  }

  closemodal() {
    this.modalRef.hide()
  }

  selectLang() {

    let value = this.mygroup.value.selectedlanguage;
    if (this.config.userData) {
      if (value == 'de') {
        value = checkLocalizationLang(this.translate, this.mygroup.value.selectedlanguage, this.config.userData.roleName.roleId == 1 ? this.config.userData.country : this.layoutService.institutionCountryId);
      }
    }

    this.translate.use(value);

    let key = 'selectedlanguage';

    localStorage.setItem(key, value);

    this.emitData = { 'value': this.mygroup.value.selectedlanguage };
    this.modalRef.hide()

    this.eventsService.languageSelectedEvent.emit(this.emitData)
  }

}
